import React from "react";
import { useFormContext } from "../../context/FormContext";
import styles from "./Footer.module.css";

const Footer = () => {
  const { merchant_name, merchant } = useFormContext();
  return (
    <div className={styles.continer}>
      <p>
        This form was created by <strong>{merchant?.companyName || merchant_name}</strong>
      </p>
      <p>
        Powered by{" "}
        <a
          href="https://www.cicod.com/workflow-manager"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          CICOD Workflow Manager.
        </a>{" "}
      </p>
    </div>
  );
};

export default Footer;
